import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, ReactiveFormsModule],
    template: `<router-outlet></router-outlet>`
})
export class AppComponent {}
